<template>
  <div v-loading="infoLoading" style="overflow-x: hidden" class="trade-order-info">
    <ContentHeader path-set-type="replace" />
    <div class="content-container">
      <!-- 订单基本信息 -->
      <OrderBaseInfo
        :tradeApplyOrderVO="tradeApplyOrderVO"
        :tradeApplyInfoVO="tradeApplyInfoVO"
        :tradeApplyBaseVO="tradeApplyBaseVO"
        :isMineApply="isMineApply"
        @handleSuccess="init"
      >
        <!-- 订单状态进度 -->
        <OrderStepInfo ref="OrderStepInfo" :tradeApplyOrderVO="tradeApplyOrderVO" />
      </OrderBaseInfo>

      <!-- DAG文件 -->
      <UploadDag
        v-if="tradeApplyOrderVO.tradeApplyDagFileList && tradeApplyOrderVO.tradeApplyDagFileList.length"
        :isEdit="false"
        :imageList="tradeApplyOrderVO.tradeApplyDagFileList"
      />

      <!-- 订单明细 -->
      <div class="order-info">
        <div class="info-title" @click="collClick(0)">
          <i :class="[orderShow ? 'el-icon-minus' : 'el-icon-plus']"></i>
          订单明细
        </div>
        <div v-show="orderShow">
          <StoreBaseInfo
            v-if="tradeApplyOrderVO.applyType !== '02' && basePocInfo.abiOneId"
            ref="pocBaseInfo"
            :tradeApplyOrderVO="tradeApplyOrderVO"
            :tradeApplyInfoVO="tradeApplyInfoVO"
            :basePocInfo="basePocInfo"
            :tradeApplyBaseVO="tradeApplyBaseVO"
            :tradeApplyExecVO="tradeApplyExecVO"
          />
          <PocBaseInfo
            v-if="tradeApplyOrderVO.applyType !== '02' && !basePocInfo.abiOneId"
            ref="pocBaseInfo"
            :tradeApplyOrderVO="tradeApplyOrderVO"
            :tradeApplyInfoVO="tradeApplyInfoVO"
            :basePocInfo="basePocInfo"
            :tradeApplyBaseVO="tradeApplyBaseVO"
            :tradeApplyExecVO="tradeApplyExecVO"
          />

          <!--订单执行信息中的- 高端店招 -->
          <!-- <OrderExecHigh
            v-if="tradeApplyExecVO && tradeApplyExecVO.execTypeSub === '101'"
            :tradeApplyExecVO="tradeApplyExecVO"
            :tradeApplyBaseVO="tradeApplyBaseVO"
            :tradeApplyInfoVO="tradeApplyInfoVO"
          /> -->
          <!--订单执行信息中的- 物料定制 -->
          <OrderExecMaterial
            v-if="tradeApplyExecCustom"
            :tradeApplyBaseVO="tradeApplyBaseVO"
            :tradeApplyExecVO="tradeApplyExecVO"
            :tradeApplyInfoVO="tradeApplyInfoVO"
            :tradeApplyExecCustom="tradeApplyExecCustom"
          />
          <!-- isp 订单执行信息中的-isp -->
          <OrderExecIsp
            v-if="ispOrderData"
            :tradeApplyExecVO="tradeApplyExecVO"
            :tradeApplyBaseVO="tradeApplyBaseVO"
            :tradeApplyInfoVO="tradeApplyInfoVO"
            :ispOrderData="ispOrderData"
          />

          <!-- 门店执行信息 - 非批量化物料 -->
          <StoreExecInfo ref="StoreExecInfo" v-if="tradeApplyOrderVO.applyType !== '02' && !isChannelType" />
          <!--订单执行信息中的-批量化物料 -->
          <StoreBulkInfo ref="StoreBulkInfo" />
        </div>
      </div>
      <!-- 审批概览 -->
      <div class="order-info">
        <div class="info-title" @click="collClick(7)">
          <i :class="[serveyShow ? 'el-icon-minus' : 'el-icon-plus']"></i>
          {{ approveOrderTitle }}
        </div>
        <div v-show="serveyShow">
          <AcceptanceCheck
            ref="AcceptanceCheck"
            :tradeApplyOrderVO="tradeApplyOrderVO"
            :tradeApplyInfoVO="tradeApplyInfoVO"
            :tradeApplyBaseVO="tradeApplyBaseVO"
          />
        </div>
      </div>

      <!-- 操作记录 -->
      <div class="order-info">
        <div class="info-title" @click="collClick(1)">
          <i :class="[processShow ? 'el-icon-minus' : 'el-icon-plus']"></i>
          操作记录
        </div>
        <div v-show="processShow">
          <OrderProcessInfo ref="OrderProcessInfo" :processRecordList="processRecordList" />
        </div>
      </div>

      <!-- 订单评价 -->
      <OrderCommentInfo ref="OrderCommentInfo" />

      <!--按钮权限   v-if="canPass"
      v-if="canReject"-->
      <!-- 操作按钮 -->
      <div
        class="order-info info-btn"
        v-show="
          (tradeApplyInfoVO.applyStatus == '200' && tradeApplyInfoVO.solutionStatus == '240') ||
          (tradeApplyInfoVO.applyStatus == '300' && tradeApplyInfoVO.executionStatus == '340')
        "
      >
        <div class="fixed">
          <!-- v-if="canReject" -->
          <el-button class="btn-red-plain" size="small" @click="handleReject">驳回</el-button>
          <!-- v-if="canPass" -->
          <el-button class="btn-red" size="small" @click="handlePass">通过</el-button>
        </div>
      </div>

      <!-- 弹窗提示 -->
      <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" style="min-width: 430px">
        <div>
          <div class="block-content">
            <!-- 当订单是待完工状态才出现确认时间 -->
            <el-row
              class="content-row"
              style="margin-bottom: 10px"
              v-if="tradeApplyInfoVO.applyStatus == '300' && tradeApplyInfoVO.executionStatus == '340' && handleType === 'pass'"
            >
              <el-col :span="9"> <i style="color: #c8102d; font-weight: 700; margin-right: 3px">*</i>是否可作为优秀执行 </el-col>
              <el-col :span="15" class="marginLeft">
                <el-radio-group v-model="approvalFormData.excellentFlag">
                  <el-radio :label="1" class="radioCheck">是</el-radio>
                  <el-radio :label="0" class="radioCheck">否</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row class="content-row" style="margin-bottom: 10px" v-show="handleType === 'reject'">
              <el-col :span="7"> <i style="color: #c8102d; font-weight: 700; margin-right: 3px">*</i>驳回理由 </el-col>
              <el-col :span="9">
                <el-select v-model="approvalFormData.processReason" placeholder="请选择驳回理由" size="small" clearable filterable style="width: 270px">
                  <el-option v-for="(item, idx) in vendorList" :key="idx" :label="item.value" :value="item.key" />
                </el-select>
              </el-col>
            </el-row>
            <!-- <el-row class="content-row marginLeftdecre"> -->
            <el-row class="content-row">
              <el-col :span="7" style="min-width: 100px">
                <i v-if="handleType === 'reject'" style="color: #c8102d; font-weight: 700; margin-right: 3px">*</i>
                {{ handleType === 'reject' ? '具体理由说明' : '审批通过建议' }}
              </el-col>
              <el-col :span="9">
                <el-input
                  show-word-limit
                  style="width: 270px; height: 50px"
                  type="textarea"
                  resize="none"
                  :placeholder="handleType === 'reject' ? '请填写具体理由说明' : '请填写审批通过建议'"
                  v-model="approvalFormData.processRemark"
                ></el-input>
              </el-col>
            </el-row>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false">取 消</el-button>
          <el-button class="btn-red" size="small" @click="e => handleConfirm(false, e)" :loading="btnLoading">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 成功弹窗 -->
      <el-dialog title="提示" :visible.sync="succVisible" width="30%" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
        <span>{{ successText }}</span>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="returnList">返回</el-button>
          <el-button class="btn-red" size="small" @click="showInfo">查看详情</el-button>
        </span>
      </el-dialog>

      <!-- 评价弹窗 -->
      <OrderCommentDialog ref="OrderCommentDialog" @commentSuccess="commentSuccess" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ContentHeader from '@/components/content-header'
import OrderBaseInfo from './components/order-base-info'
import OrderStepInfo from './components/order-step-info'
import StoreExecInfo from './components/store-exec-info'
import OrderProcessInfo from './components/order-process-info'
import StoreBulkInfo from './components/store-bulk-info'
import OrderCommentInfo from './components/order-comment-info'
import OrderCommentDialog from './components/order-comment-dialog'
import PocBaseInfo from './components/poc-base-info'
import StoreBaseInfo from './components/store-base-info.vue'
import OrderExecMaterial from './components/order-exec-material'
import OrderExecIsp from './components/order-exec-isp'
import AcceptanceCheck from './components/acceptance-check.vue'
import UploadDag from './components/upload-dag'

export default {
  name: 'trade-order-info',
  components: {
    AcceptanceCheck,
    ContentHeader,
    OrderBaseInfo,
    OrderStepInfo,
    StoreExecInfo,
    OrderProcessInfo,
    StoreBulkInfo,
    OrderCommentInfo,
    OrderCommentDialog,
    PocBaseInfo,
    StoreBaseInfo,
    OrderExecMaterial,
    OrderExecIsp,
    UploadDag
  },
  data () {
    return {
      approveOrderTitle: '方案明细',
      tradeApplyOrderVO: '',
      tradeApplyInfoVO: '',
      tradeApplyBaseVO: '',
      tradeApplyBizVO: '',
      tradeApplyExecVO: '',
      tradeApplyExecCooler: '',
      tradeApplyExecCustom: '',
      tradeApplyExecStack: '',
      tradeApplyProcessRecordVO: '',
      tradeBmApplyDetailList: '',
      tradeBmApplyImageList: '',
      processRecordList: [],
      ispOrderData: '',
      tradeApplyExecPboDTO: '',
      employeeLevel: null,
      defaultBuType: '',
      vendorList: [],
      execTypeSub: '',
      infoLoading: false,
      btnLoading: false,
      serveyShow: true,
      orderShow: true,
      processShow: true,//操作记录
      planShow: true,
      acceptShow: true,
      quotaShow: true,
      investmentShow: true,
      buQuotaShow: true,

      isMineApproval: false,
      isMineApply: false,
      dialogVisible: false,
      succVisible: false,
      handleType: '',
      handleText: '',
      successText: '',

      // 按钮权限
      canReject: false,
      canPass: false,
      canAccept: false,
      canSupplier: false,
      canReceipt: false,
      supplierSelectShow: false,
      supplierSelectShowOn130: false,

      expenseInfoShow: false,
      budgetSelectShow: false,
      planDetailShow: false,
      acceptDetailShow: false,
      supplementShow: false,

      approvalFormData: {
        processReason: '',
        processTime: '',
        excellentFlag: '',
        // acceptanceApproveTime: "",
        applyId: '',
        approvalResult: '', // 02审批通过，03审批退回
        processRemark: '', // 如驳回，驳回理由
        vendorId: '', // 服务商
        processClientId: '', // 操作人Id
        processClientName: '', // 操作人名字
        trCode: '', // TRCode
        quotaId: '', // 配额ID
        ledgerAccount: '', // 总账科目
        costCenterCode: '', // 成本中心
        mmr12: '', // mmr12
        clientType: '', // 用户类型 01百威 02ISP
        applyType: '', // 对应申请单类型 01高端店招 02物料定制 03批量化物料 04完美门店
        approvalType: '', // 01需求审批 02费用审批 03验收审批
        tradeApplyExecCoolerList: [] // 资产冰柜
      },

      commentVisible: false,
      commentParams: {
        applyId: '',
        qualityScoreValue: '',
        speedScoreValue: '',
        tmComment: ''
      },
      hasComment: false,

      basePocInfo: '',

      // tradeApplyOrderPocCheckInfo: {},

      completeStandardDialog: false,
      historyInvestmentInfo: {}
    }
  },
  computed: {
    ...mapGetters(['userInfo']),

    // 是否是渠道项目
    isChannelType () {
      return (
        this.tradeApplyExecVO ||
        this.tradeApplyExecCooler ||
        this.tradeApplyExecCustom ||
        this.ispOrderData
      )
    },
    // 是否显示历史投入
    showHistoryInvestment () {
      if (!this.historyInvestmentInfo) {
        return false
      }
      return (
        this.historyInvestmentInfo.money?.detailList?.length ||
        this.historyInvestmentInfo.cooler?.detailList?.length ||
        this.historyInvestmentInfo.beer?.detailList?.length
      )
    },
    needCheckPoc () {
      return !!(this.tradeApplyExecVO && ['102', '105', '201', '202', '302', '303'].includes(this.tradeApplyExecVO.execTypeSub) && this.basePocInfo.abiPocId)
    }
  },
  watch: {
    tradeApplyInfoVO () {
      if ((this.tradeApplyInfoVO.applyStatus === '200' && this.tradeApplyInfoVO.solutionStatus === '240') || (this.tradeApplyInfoVO.applyStatus === '300' && this.tradeApplyInfoVO.executionStatus === '340')) {
        this.approveOrderTitle = '审批概览'
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.getOrderInfo()
      // this.getSupplier();
      // this.tradeApplyApproveInfo();
    },
    // 获取订单信息
    getOrderInfo () {
      this.infoLoading = true
      this.$store
        .dispatch('getOrderDetail', this.$route.query.applyId)
        .then((res) => {
          this.infoLoading = false
          if (res.data.resultCode === '0') {
            // console.log(
            //   res.data.resultData.tradeApplyOrderVO,
            //   "tradeApplyOrderVO,订单详情"
            // );
            this.tradeApplyOrderVO = res.data.resultData.tradeApplyOrderVO
            this.tradeApplyInfoVO = this.tradeApplyOrderVO.tradeApplyInfoVO
            this.tradeApplyBaseVO = Object.assign(
              {},
              this.tradeApplyOrderVO.basePocInfo,
              this.tradeApplyOrderVO.tradeApplyBaseVO
            )
            this.tradeApplyBizVO =
              this.tradeApplyOrderVO.tradeApplyBizVO ||
              this.tradeApplyOrderVO.basePocInfo
            this.tradeApplyExecVO = this.tradeApplyOrderVO.tradeApplyExecVO
            this.tradeApplyExecCooler =
              this.tradeApplyOrderVO.tradeApplyExecCooler
            this.tradeApplyExecCustom =
              this.tradeApplyOrderVO.tradeApplyExecCustom
            this.tradeApplyExecStack =
              this.tradeApplyOrderVO.tradeApplyExecStack
            this.tradeApplyProcessRecordVO =
              this.tradeApplyOrderVO.tradeApplyProcessRecordVO
            this.tradeBmApplyDetailList =
              this.tradeApplyOrderVO.tradeBmApplyDetailList
            this.tradeBmApplyImageList =
              this.tradeApplyOrderVO.tradeBmApplyImageList
            this.processRecordList =
              this.tradeApplyOrderVO.processRecordList || []
            this.ispOrderData = this.tradeApplyOrderVO.ispOrderData
            this.tradeApplyExecPboDTO =
              this.tradeApplyOrderVO.tradeApplyExecPboDTO
            this.basePocInfo = this.tradeApplyOrderVO.basePocInfo

            if (this.isChannelType) {
              this.$nextTick(() => {
                this.$refs.pocBaseInfo.initMap(this.basePocInfo)
              })
            }
            // if (this.tradeApplyExecVO.execTypeSub === '101' || this.tradeApplyExecVO.execTypeSub === '102') {
            //   this.getApprovePocCheckStandard(this.tradeApplyExecVO.execTypeSub)
            // }
            // 审批人是否是本人
            if (
              this.userInfo.clientId ===
              this.tradeApplyInfoVO.approvalClientId ||
              (this.userInfo.regionTMClientId ===
                this.tradeApplyInfoVO.approvalClientId &&
                this.userInfo.employeeLevel === 45)
            ) {
              this.isMineApproval = true
            } else {
              this.isMineApproval = false
            }

            // 是否是本人提报
            this.isMineApply =
              this.userInfo.clientId === this.tradeApplyInfoVO.applyClientId

            // 进度条
            this.$refs.OrderStepInfo.setOrderStatusList(this.tradeApplyOrderVO)

            // 非批量化物料
            if (
              this.tradeApplyOrderVO.applyType === '01' ||
              this.tradeApplyOrderVO.applyType === '03'
            ) {
              // 补充信息
              this.$refs.OrderSupplementInfo.setShowInfo(
                this.tradeApplyOrderVO,
                this.userInfo
              )

              if (!this.tradeApplyExecCooler) {
                this.$nextTick(() => {
                  if (this.$refs.StoreBaseInfo) {
                    this.$refs.StoreBaseInfo.initMap(this.tradeApplyBaseVO)
                  }
                })
              }
              if (!this.isChannelType) {
                this.$refs.StoreExecInfo.setExecInfo(this.tradeApplyOrderVO)
              }
            } else if (this.tradeApplyOrderVO.applyType === '04') {
              if (!this.isChannelType) {
                this.$refs.StoreExecInfo.setExecInfo(this.tradeApplyOrderVO)
              }
              const mapInfo = {}
              this.tradeApplyExecPboDTO.tradePboCirclePocList.forEach(
                (item) => {
                  if (item.pocType === 'main') {
                    mapInfo.locLatitude = item.circlePocLat
                    mapInfo.locLongitude = item.circlePocLong
                    mapInfo.pocName = item.circlePocName
                    mapInfo.detailAddress = item.circlePocAddress
                  }
                }
              )
              this.$nextTick(() => {
                this.$refs.StoreBaseInfo.initMap(mapInfo)
              })
            } else {
              this.$refs.StoreBulkInfo.setBulkInfo(this.tradeApplyOrderVO)
            }
            // 审批概览
            // this.$refs.OrderExpenseInfo.setExpenseInfo(this.tradeApplyOrderVO)
            // 方案明细
            this.$refs.OrderPlanDetail.setPlanInfo(this.tradeApplyInfoVO)
            // 验收详情
            this.$refs.OrderAcceptDetail.setAcceptInfo(this.tradeApplyOrderVO)

            // 评价
            if (this.tradeApplyInfoVO.tradeApplyEvaluateDTO) {
              this.$refs.OrderCommentInfo.setCommentInfo(
                this.tradeApplyInfoVO.tradeApplyEvaluateDTO
              )
            }

            this.defaultBuType = this.userInfo.defaultBuType
            this.employeeLevel = this.userInfo.employeeLevel

            // 选项权限
            this.setSelectAuth()
            // 按钮权限
            this.setBtnAuth()
            // 审批详情权限
            this.setDetailAuth()
          }
        })
        .catch(() => {
          this.infoLoading = false
        })
    },

    // 设置选项显示
    setSelectAuth () {
      this.expenseInfoShow = false
      this.budgetSelectShow = false
      this.supplementShow = false

      const solutionStatus = this.tradeApplyInfoVO.solutionStatus
      const applyStatus = this.tradeApplyInfoVO.applyStatus
      const acceptanceStatus = this.tradeApplyInfoVO.acceptanceStatus

      // 预算
      if (
        this.isMineApproval &&
        (((this.employeeLevel === 50 || this.employeeLevel === 45) &&
          applyStatus === '200' &&
          solutionStatus === '250') ||
          (this.tradeApplyInfoVO.applyClientLevel === 60 &&
            this.employeeLevel === 60 &&
            solutionStatus === '270')) &&
        applyStatus === '200'
      ) {
        this.budgetSelectShow = true
      }

      // 审批概览显示
      if (
        applyStatus === '200' &&
        (solutionStatus === '210' || Number(solutionStatus) >= 250)
      ) {
        this.expenseInfoShow = true
      }

      // 补充信息显示
      if (this.tradeApplyOrderVO.applyType !== '02') {
        if (
          (this.isMineApply ||
            this.employeeLevel === 45 ||
            this.employeeLevel === 50 ||
            (this.defaultBuType === '03' && this.employeeLevel === 60)) &&
          Number(acceptanceStatus) < 420 &&
          (!this.tradeApplyBizVO.dianpinImage ||
            !this.tradeApplyBizVO.wccsId) &&
          applyStatus !== '900' &&
          applyStatus !== '0' &&
          !this.tradeApplyExecCooler &&
          !this.tradeApplyExecStack
        ) {
          this.supplementShow = true
        }
      } else {
        this.supplementShow = false
      }
    },

    // 设置按钮权限
    setBtnAuth () {
      this.canReject = false
      this.canPass = false
      this.canAccept = false
      this.canSupplier = false
      this.canReceipt = false
      this.supplierSelectShow = false
      this.supplierSelectShowOn130 = false
      // 驳回
      if (!this.tradeApplyExecStack) {
        // 非堆箱
        if (
          this.tradeApplyInfoVO.solutionStatus !== '210' &&
          this.tradeApplyInfoVO.acceptanceStatus !== '450' &&
          this.tradeApplyInfoVO.acceptanceStatus !== '410'
        ) {
          this.canReject = true
        }
      } else {
        // 堆箱
        if (
          this.tradeApplyInfoVO.requirementStatus === '120' ||
          this.tradeApplyInfoVO.requirementStatus === '130'
        ) {
          this.canReject = true
          this.canPass = true
        }
      }

      // 通过
      if (!this.tradeApplyExecStack) {
        // 非堆箱
        if (
          this.tradeApplyInfoVO.solutionStatus !== '210' &&
          this.tradeApplyInfoVO.applyStatus !== '400'
        ) {
          this.canPass = true
        }
      }

      // 验收
      if (
        this.tradeApplyInfoVO.solutionStatus !== '210' &&
        this.tradeApplyInfoVO.applyStatus === '400' &&
        this.tradeApplyInfoVO.acceptanceStatus === '420'
      ) {
        this.canAccept = true
      }

      // 提交供应商
      // 百威： 高端店招、物料定制 状态130/210，角色为45TM助理/50TM；
      // ISP： 303物料定制 状态140 角色60 BUISPTM； 301高端执行、302形象店 状态130 角色60 BUISPTM
      let execTypeSub = ''
      if (this.tradeApplyOrderVO.tradeApplyExecVO) {
        execTypeSub = this.tradeApplyOrderVO.tradeApplyExecVO.execTypeSub
      }
      if (
        this.tradeApplyOrderVO.applyType === '01' &&
        (this.employeeLevel === 45 || this.employeeLevel === 50) &&
        (this.tradeApplyExecVO || this.tradeApplyExecCustom) &&
        !this.tradeApplyExecCooler
      ) {
        if (
          this.tradeApplyInfoVO.applyStatus === '100' &&
          this.tradeApplyInfoVO.requirementStatus === '130'
        ) {
          this.supplierSelectShowOn130 = true
          this.canPass = true
        }
        if (this.tradeApplyInfoVO.solutionStatus === '210') {
          this.canSupplier = true
          this.canPass = false
        }
      } else if (
        this.tradeApplyOrderVO.applyType === '03' &&
        this.tradeApplyInfoVO.applyStatus === '100' &&
        !this.tradeApplyInfoVO.vendorName
      ) {
        if (
          execTypeSub === '303' &&
          this.tradeApplyInfoVO.requirementStatus === '140' &&
          this.employeeLevel === 60
        ) {
          this.supplierSelectShow = true
          this.canPass = false
        } else if (
          this.tradeApplyInfoVO.requirementStatus === '130' &&
          (this.employeeLevel === 45 || this.employeeLevel === 50)
        ) {
          this.supplierSelectShow = true
          this.canPass = false
        }
      }

      // 确认收货
      if (
        (this.employeeLevel === 45 ||
          this.employeeLevel === 50 ||
          this.employeeLevel === 60) &&
        this.tradeApplyInfoVO.acceptanceStatus === '450'
      ) {
        this.canReceipt = true
      }
    },

    // 设置审批详情权限
    setDetailAuth () {
      this.planDetailShow = false
      this.acceptDetailShow = false

      if (this.tradeApplyOrderVO.applyType !== '03') {
        if (
          Number(this.tradeApplyInfoVO.solutionStatus) >= 220 &&
          !this.tradeApplyExecCooler
        ) {
          this.planDetailShow = true
        }
      } else {
        if (
          Number(this.tradeApplyInfoVO.requirementStatus) >= 140 &&
          this.tradeApplyInfoVO.vendorName
        ) {
          this.planDetailShow = true
        }
      }

      if (
        Number(this.tradeApplyInfoVO.acceptanceStatus) >= 420 &&
        !this.tradeApplyExecCooler &&
        this.employeeLevel >= 40
      ) {
        this.acceptDetailShow = true
      }
    },

    // 驳回按钮
    handleReject () {
      this.dialogVisible = true
      this.handleText = ''
      this.handleType = 'reject'
      if (
        this.tradeApplyInfoVO.applyStatus === '200' &&
        this.tradeApplyInfoVO.solutionStatus === '240'
      ) {
        // 调接口获取报价审批驳回原因
        this.$store
          .dispatch('getStatus', { name: 'dsxQuotaProcessReasonMap' })
          .then((res) => {
            if (res.data.resultCode === '0') {
              // console.log(res.data, "调接口获取审批驳回原因");
              this.vendorList = res.data.resultData.dsxQuotaProcessReasonMap || []
            }
          })
      }
      if (
        this.tradeApplyInfoVO.applyStatus === '300' &&
        this.tradeApplyInfoVO.executionStatus === '340'
      ) {
        // 调接口获取报价验收驳回原因
        this.$store
          .dispatch('getStatus', { name: 'dsxVerifyProcessReasonMap' })
          .then((res) => {
            if (res.data.resultCode === '0') {
              // console.log(res.data, "调接口获取验收驳回原因");
              this.vendorList = res.data.resultData.dsxVerifyProcessReasonMap || []
            }
          })
      }
    },

    // 通过按钮
    handlePass () {
      if (this.needCheckPoc && this.tradeApplyInfoVO.applyStatus < 300 && this.basePocInfo.abiPocStatus === 2) {
        this.$confirm('单据无法通过，该门店已永久关店。请驳回单据，驳回后订单将自动关闭。', '提示', {
          customClass: 'custom-message-box',
          confirmButtonText: '驳回',
          confirmButtonClass: 'custom-message-box-confirm-btn',
          cancelButtonClass: 'btn-red-plain',
          distinguishCancelAndClose: true,
          showClose: false,
          closeOnClickModal: false,
          callback: action => {
            if (action === 'confirm') {
              this.handleType = 'reject'
              this.handleConfirm(true)
            }

          }
        })
        return
      }
      this.handleType = 'pass'
      this.handleText = ''
      this.dialogVisible = true
    },

    // 验收评价弹框
    handleAccept () {
      if (!this.tradeApplyInfoVO.tradeApplyEvaluateDTO && !this.hasComment) {
        this.$refs.OrderCommentDialog.commentShow()
        return
      }
      this.dialogVisible = true
      this.handleText = ''
      this.handleType = 'accept'
    },

    // 提交供应商
    handleSupplier () {
      if (this.tradeApplyExecCustom) {
        if (!this.approvalFormData.vendorId) {
          this.$message.error('请选择服务商')
          return
        }
        this.handleText = '是否确认分配该服务商?'
      } else {
        this.handleText = ''
      }

      this.dialogVisible = true
      this.handleType = 'supplier'
    },

    // 确认收货
    handleReceipt () {
      this.dialogVisible = true
      this.handleType = 'receipt'
      this.handleText = '是否确认收货?'
    },

    // 弹窗确认
    handleConfirm (needCheck) {
      console.log(needCheck)
      if (this.btnLoading) {
        return
      }

      this.approvalFormData.applyId = this.tradeApplyOrderVO.applyId
      // this.approvalFormData.approvalType = approvalType;
      this.approvalFormData.processClientId = this.userInfo.clientId
      this.approvalFormData.processClientName = this.userInfo.clientName

      // 审批驳回
      if (this.handleType === 'reject') {
        this.successText = '订单驳回成功'
        if (!needCheck && !this.approvalFormData.processReason) {
          this.$message.error('请选择驳回理由')
          return
        }
        if (!needCheck && !this.approvalFormData.processRemark) {
          this.$message.error('请填写具体理由说明')
          return
        }
        this.approvalFormData.approvalResult = '03'
      }
      // 审批通过
      if (this.handleType === 'pass') {
        this.successText = '订单审批成功'
        if ((this.tradeApplyInfoVO.applyStatus === '300' &&
          this.tradeApplyInfoVO.executionStatus === '340') && this.approvalFormData.excellentFlag === '') {
          this.$message.error('请选择是否可作为优秀执行')
          return
        }
        this.approvalFormData.tradeApplyExecCoolerList = []
        this.approvalFormData.approvalResult = '02'
      }
      // 调用接口
      // 审批审批
      if (
        this.tradeApplyInfoVO.applyStatus === '200' &&
        this.tradeApplyInfoVO.solutionStatus === '240'
      ) {
        this.btnLoading = true
        this.$store
          .dispatch('getBccApproveQuote', this.approvalFormData)
          .then((res) => {
            this.btnLoading = false
            if (res.data.resultCode === '0') {
              this.dialogVisible = false
              this.succVisible = true
            }
          })
          .catch(() => {
            this.btnLoading = false
          })
      }
      // 验收审批
      if (
        this.tradeApplyInfoVO.applyStatus === '300' &&
        this.tradeApplyInfoVO.executionStatus === '340'
      ) {
        this.btnLoading = true
        this.$store
          .dispatch('getBccCheck', this.approvalFormData)
          .then((res) => {
            this.btnLoading = false
            if (res.data.resultCode === '0') {
              this.dialogVisible = false
              this.succVisible = true
            }
          })
          .catch(() => {
            this.btnLoading = false
          })
      }
    },

    // 返回订单列表
    returnList () {
      this.$router.go(-1)
    },

    // 查看详情
    showInfo () {
      this.succVisible = false
      // 查看详情，仅仅只是详情页，没有按钮
      this.init()
    },

    collClick (index) {
      if (!index) {
        this.orderShow = !this.orderShow
      } else if (index === 1) {
        this.processShow = !this.processShow
      } else if (index === 2) {
        this.planShow = !this.planShow
      } else if (index === 3) {
        this.acceptShow = !this.acceptShow
      } else if (index === 4) {
        this.quotaShow = !this.quotaShow
      } else if (index === 5) {
        this.investmentShow = !this.investmentShow
      } else if (index === 6) {
        this.buQuotaShow = !this.buQuotaShow
      } else if (index === 7) {
        this.serveyShow = !this.serveyShow
      }
    },

    qualityClick (val) {
      this.commentParams.qualityScoreValue = val
    },

    speedClick (val) {
      this.commentParams.speedScoreValue = val
    },

    commentSuccess () {
      this.hasComment = true
      this.handleAccept()
    },
    tableBorderRight ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 3) {
        return 'border-right:1px solid #EBEEF5;'
      }
    },

    showCompleteStandard () {
      this.completeStandardDialog = true
    },
    // 表格样式
    tableHeaderRowClassName ({ rowIndex }) {
      if (rowIndex === 0) {
        return 'quota-table-row-0'
      }
      if (rowIndex === 1) {
        return 'quota-table-row-1'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  min-width: 430px;
}
::v-deep .el-radio .el-radio__input {
  display: inline-block;
  margin-right: 5px;
}
::v-deep .el-radio .el-radio__input.is-checked + .el-radio__label {
  color: $base-blue;
}
.content-container {
  padding-bottom: 20px;
}
.info-title {
  font-size: $font-16;
  font-weight: bold;
  cursor: pointer;
  margin-bottom: 10px;

  i {
    font-weight: bold;
  }
}

.fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100px;
  line-height: 100px;
  background: #f3f5f9;
  z-index: 10;
}
.info-btn {
  text-align: center;
  height: 42px;
  .el-button {
    padding-left: 40px;
    padding-right: 40px;
    margin: 10px 25px 0 25px;
  }
}

.block-content {
  line-height: 30px;
}

::v-deep .el-switch.is-disabled .el-switch__core,
.el-switch.is-disabled .el-switch__label {
  cursor: pointer !important;
}

::v-deep .el-switch.is-disabled {
  opacity: 1;
}
.standard-title {
  font-size: 0px;
  color: #cacbca;
  cursor: pointer;
  width: 14px;
  height: 14px;
  display: inline-block;
  line-height: 18px;
  img {
    width: 100%;
  }
}
.investment-table {
  width: 100%;
  border: 1px solid #ebeef5;
  border-radius: 5px;
  margin-top: 30px;
  border-collapse: collapse;
  line-height: 23px;
  i {
    display: inline-block;
    width: 16px;
    height: 16px;
    line-height: 16px;
    img {
      width: 100%;
    }
  }
  th {
    padding: 12px 0;
    background: #f5f7fa;
    color: rgb(56, 55, 55);
  }
  td {
    // width: 130px;
    text-align: center;
    border: 1px solid #ebeef5;
    padding: 12px 0;
    box-sizing: border-box;
    color: #606266;
    &:nth-child(1) {
      width: 205px;
    }
    &:nth-child(2) {
      width: 400px;
    }
    &:nth-child(3) {
      width: 400px;
    }
    &:nth-child(2) {
      width: 400px;
    }
  }
  .isMeet {
    color: #3faa1d;
  }
  .Meet {
    color: #f29613;
  }
}
</style>
<style lang="scss">
.trade-order-info {
  .el-message-box .el-message-box__btns {
    margin-top: 20px;
    text-align: center;
    .el-button--primary {
      background-color: #c8102d;
      border-color: #c8102d;
    }
  }
  .el-message-box__wrapper {
    bottom: 350px;
  }
  .history-investment-box {
    display: flex;
    text-align: center;
    border: 1px solid #ebeef5;
    margin-top: 20px;
    border-radius: 5px;
    .history-investment {
      border-right: 1px solid #ebeef5;
      flex: 1;
      .investment-title {
        font-size: 18px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px 0 10px;
        border-bottom: 1px solid #ebeef5;
        span {
          &:last-child {
            color: #c8102d;
            font-weight: 700;
            line-height: 35px;
          }
        }
      }
      .investment-content {
        padding: 0 60px;
        div {
          display: flex;
          justify-content: space-around;
          padding: 16px 0;
        }
      }
    }
  }
  .trade-order-block .content-row {
    margin-top: 15px;
  }

  .complete-standard-info {
    img {
      width: 100%;
      image-rendering: -moz-crisp-edges;
      image-rendering: -o-crisp-edges;
      image-rendering: -webkit-optimize-contrast;
      image-rendering: crisp-edges;
      -ms-interpolation-mode: nearest-neighbor;
    }
  }
  // .el-table thead.is-group th.el-table__cell{
  //   background-color: #fff;
  // }
  .quota-table-row-0 th {
    border-right: 0 !important;
    color: rgb(56, 55, 55);
  }
  .quota-table-row-1 th {
    // color: red;
    background-color: #fff !important;
  }
  // .quota-table-row th.el-table__cell{
  //       //  background-color: #fff;
  // }
  .radioCheck {
    margin-left: 50px;
  }

  .marginLeft {
    margin-left: -40px;
  }
  /* .marginLeftdecre {
  margin-left: 9px;
} */
}
</style>
